module.exports = __webpack_public_path__ + "img/break.51bb0503.svg";